<template>
  <v-dialog v-model="dialog.show" max-width="500px" persistent>
    <v-card style="padding: 1px">
      <v-card-title> </v-card-title>
      <font-awesome-icon :icon="dialog.icon" size="3x" />

      <v-card-text
        ><span style="line-height: 1.5;" v-html="dialog.message"> </span
      ></v-card-text>

      <v-row class="ltr" style="margin: 25px 10px 5px 5px !important">
        <template v-if="dialog.type == 0">
          <v-btn
            color="green white--text"
            class="dialogButton"
            rounded
            @click="$emit('close')"
          >
            تایید
          </v-btn>
        </template>
        <template v-else>
          <v-btn
            color="green white--text"
            class="dialogButton"
            rounded
            @click="$emit('close', dialog.key)"
          >
            بلی
          </v-btn>

          <v-btn class="dialogButton" rounded @click="$emit('close', -1)">
            خیر
          </v-btn>
        </template>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  computed: {
    icon() {
      return "../assets/" + this.dialog.icon + ".png";
    },
    dialog() {
      return this.$store.getters.dialog;
    },
  },
};
</script>
<style scoped>
.v-card__text {
  padding: 20px 50px 0px 50px !important;
  font-size: 18px;
  text-align: center;
}

.v-card {
  margin: 0;
  border-radius: 4px !important;
}

.fa-times {
  color: unset !important;
  margin-top: unset !important;

  float: unset !important;
  cursor: unset !important;
  margin-right: 0 !important;
}
</style>
